import React from 'react';

import { Container } from './styles';

const ContainerBoxWhite = ({ children, small }) => {
  return <Container small={small}>{children}</Container>;
};

export default ContainerBoxWhite;
